import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

export const initDatadogLogs = (
  dataDogClientToken: string,
  country: string,
  env: string,
  gitTag: string
) => {
  datadogLogs.init({
    site: "datadoghq.com",
    clientToken: dataDogClientToken,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: "all",
    service: "webchat",
    version: gitTag,
    env,
  });
  datadogLogs.setGlobalContext({ country });
};

export const initDatadogRum = (
  country: string,
  env: string,
  gitTag: string,
  dataDogAppId: string,
  dataDogClientToken: string
) => {
  datadogRum.init({
    applicationId: dataDogAppId,
    clientToken: dataDogClientToken,
    site: "datadoghq.com",
    service: "webchat",
    version: gitTag,
    env,
    plugins: [reactPlugin],
    trackUserInteractions: false,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: "mask-user-input",
  });
  datadogRum.setGlobalContext({ country });
};
